/**
 * RouteErrorFallback — 라우터 errorElement (v1/v2 셸 밖에서 전체 화면으로 뜬다)
 *
 * - 옛 청크 로드 실패(FIKET-359): 1회 자동 새로고침. 쿨다운에 걸리면(직전 새로고침도 실패) 안내 + 새로고침 버튼
 * - 그 외 렌더 에러: 일반 안내 + 새로고침 / 홈으로
 */
import { useEffect, useState } from 'react'
import { isRouteErrorResponse, useRouteError } from 'react-router'
import { Button } from '@/components/ui/button'
import { isStaleChunkError, reloadOnceForStaleChunk } from '@/lib/chunkReload'

export function RouteErrorFallback() {
  const error = useRouteError()
  const stale = isStaleChunkError(error)
  const [reloadBlocked, setReloadBlocked] = useState(false)

  useEffect(() => {
    if (stale) {
      if (!reloadOnceForStaleChunk()) setReloadBlocked(true)
      return
    }
    // 일반 에러는 콘솔에 남겨 조사 가능하게(errorElement 가 삼키면 흔적이 없다)
    console.error('[route-error]', error)
  }, [stale, error])

  // 새로고침 예약됨 — 잠깐 로딩만 보이고 곧 새 버전으로 뜬다
  if (stale && !reloadBlocked) {
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">
        새 버전을 불러오는 중…
      </div>
    )
  }

  const title = stale ? '새 버전이 배포되었습니다' : '문제가 발생했습니다'
  const description = stale
    ? '페이지를 다시 불러와야 합니다. 새로고침을 눌러주세요.'
    : isRouteErrorResponse(error)
      ? `${error.status} ${error.statusText}`
      : error instanceof Error
        ? error.message
        : '잠시 후 다시 시도해 주세요.'

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
      <h2 className="text-lg font-semibold">{title}</h2>
      <p className="max-w-md break-all text-sm text-muted-foreground">{description}</p>
      <div className="flex gap-2">
        <Button onClick={() => window.location.reload()}>새로고침</Button>
        {!stale && (
          <Button variant="outline" onClick={() => window.location.assign('/')}>
            홈으로
          </Button>
        )}
      </div>
    </div>
  )
}
